"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M9.661 4.714h5.4l1.442 2.928a.86.86 0 0 0 .8.5h4.267v11.143H2.714V8.143h4.27a.825.825 0 0 0 .085 0 .859.859 0 0 0 .664-.411l1.928-3.018ZM22.428 21a.857.857 0 0 0 .857-.857V7.286a.857.857 0 0 0-.857-.857h-4.609l-1.452-2.95A.857.857 0 0 0 15.578 3H9.143a.857.857 0 0 0-.832.652.879.879 0 0 0-.048.068L6.53 6.428H1.857A.857.857 0 0 0 1 7.286v12.857a.857.857 0 0 0 .857.857h20.571Zm-7.714-7.714a2.571 2.571 0 1 1-5.142 0 2.571 2.571 0 0 1 5.142 0Zm1.714 0a4.286 4.286 0 1 1-8.572 0 4.286 4.286 0 0 1 8.572 0Z",
    clipRule: "evenodd"
  })]
});